import React, { useEffect } from "react";
import { useSocket } from "./useSocket";

export const useMatchSocket = ({ socketUrl, channel, event, sport, setMatch }) => {
    const socket = useSocket(socketUrl);

    useEffect(() => {
        if (!socket) return;

        const handleSocketEvent = (e) => {
            console.log(e?.data, 'socket Data')
            setMatch(sport === "cricket" || sport === "football" ? e?.data?.data : e?.data);
        };

        socket?.channel(channel)?.listen(event, handleSocketEvent);

        return () => socket?.connector?.socket?.disconnect();
    }, [socket, channel, event, sport, setMatch]);

    return socket;
};
